import { IconFn, IconSvg } from "../createIcon";

export const HelpOutlineIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 42, height: 42 }} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.75 38C30.2769 38 38 30.2769 38 20.75C38 11.2231 30.2769 3.5 20.75 3.5C11.2231 3.5 3.5 11.2231 3.5 20.75C3.5 30.2769 11.2231 38 20.75 38ZM20.75 41C31.9338 41 41 31.9338 41 20.75C41 9.56623 31.9338 0.5 20.75 0.5C9.56623 0.5 0.5 9.56623 0.5 20.75C0.5 31.9338 9.56623 41 20.75 41Z"
      fill={color}
    />
    <path
      d="M21 8.5C18.8272 8.50276 16.7441 9.36713 15.2077 10.9035C13.6713 12.44 12.8069 14.523 12.8042 16.6958H16.9708C16.9708 14.4729 18.7792 12.6667 21 12.6667C23.2208 12.6667 25.0292 14.4729 25.0292 16.6958C25.0292 17.9417 24.0271 18.8458 22.4958 20.0833C21.9956 20.4752 21.5151 20.8917 21.0563 21.3312C18.9771 23.4083 18.9167 25.6146 18.9167 25.8604V27.25H23.0833L23.0812 25.9312C23.0833 25.8979 23.15 25.1271 24 24.2792C24.3125 23.9667 24.7063 23.6542 25.1146 23.325C26.7375 22.0104 29.1937 20.025 29.1937 16.6958C29.1921 14.523 28.3284 12.4397 26.7922 10.9031C25.2559 9.36647 23.1728 8.50221 21 8.5ZM18.9167 29.3333H23.0833V33.5H18.9167V29.3333Z"
      fill={color}
    />
  </IconSvg>
);
